import React from 'react';

interface RDKitStructureProps {
  smiles: string;
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const RDKitStructure: React.FC<RDKitStructureProps> = ({
  smiles,
  width = 200,
  height = 150,
  className,
  style,
}) => {
  if (!smiles) return null;

  const renderWidth = width * 2;  // 2x for retina
  const renderHeight = height * 2;

  return (
    <img
      src={`/api/v1/render?smiles=${encodeURIComponent(smiles)}&width=${renderWidth}&height=${renderHeight}`}
      alt="Chemical structure"
      className={className}
      style={{ width, height, objectFit: 'contain', ...style }}
      loading="lazy"
    />
  );
};

export default RDKitStructure;
